export const HC_NAME_MAP = {
  // Old short names (legacy)
  'Kamrup M':  'KamrupMetropolitan',
  'Karbi A':   'KarbiAnglong',
  'W Karbi A': 'KarbiAnglong',
  'S Salmara': 'Dhubri',

  // Full API names → GeoJSON names
  'Kamrup Metro':             'KamrupMetropolitan',
  'Kamrup Rural':             'Kamrup',
  'Sibsagar':                 'Sivasagar',
  'Dima Hasao':               'DimaHasao',
  'Karbi Anglong':            'KarbiAnglong',
  'West Karbianglong':        'KarbiAnglong',
  'South Salmara-Mankachar':  'Dhubri',
  'Sribhumi':                 'Karimganj',

  // Newer districts → parent GeoJSON districts
  'Biswanath':  'Sonitpur',
  'Charaideo':  'Sivasagar',
  'Hojai':      'Nagaon',
  'Majuli':     'Jorhat',
  'Bajali':     'Barpeta',
  'Tamulpur':   'Baksa',
};

export function availMapColor(v) {
  if (v >= 90) return '#16a34a';
  if (v >= 75) return '#f59e0b';
  return '#dc2626';
}

export function expiryMapColor(v) {
  if (v === 0) return '#064e3b';
  if (v <= 5) return '#86efac';
  if (v <= 10) return '#fde68a';
  if (v <= 15) return '#f97316';
  return '#dc2626';
}

export function stockoutMapColor(v) {
  if (v === 0) return '#064e3b';
  if (v <= 5) return '#86efac';
  if (v <= 10) return '#fde68a';
  if (v <= 20) return '#f97316';
  return '#dc2626';
}

export function expiredMapColor(v) {
  if (v === 0) return '#064e3b';
  if (v <= 2) return '#86efac';
  if (v <= 5) return '#fde68a';
  if (v <= 10) return '#f97316';
  return '#dc2626';
}
